import React, { Component } from 'react';
import cloud from '../img/cloud.svg';
import downArrow from '../img/down-arrow.svg';
import '../css/App.css';

class Grid extends Component {
  state = {grid: []}
  componentDidMount() {
    var grid = [];
    for(let x = 0 ; x < 100 ; x++) {
      if(100- this.props.num <= x) {
        grid.push(this.props.color)
      } else {
        grid.push('rgba(255,255,255,0.3)')
      }
    }

    this.setState({grid: grid});
  }
  render() {
    var grid = this.state.grid.map((item, i) => {
      return <div key={"grid"+i} className="grid-cell"><div className="grid-cell-inner" style={{background: item}}></div></div>
    });
    return (
      <div className="grid">
        {grid}
      </div>

    );
  }
}

export default Grid;



// WEBPACK FOOTER //
// ./src/js/Grid.js